import { render, staticRenderFns } from "./slot4.vue?vue&type=template&id=4a79a3ee&scoped=true&"
import script from "./slot4.vue?vue&type=script&lang=js&"
export * from "./slot4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a79a3ee",
  null
  
)

export default component.exports